import { Grid, makeStyles } from "@material-ui/core";
import AttachmentModel from "api/models/AttachmentModel";
import AttachmentCard from "components/Attachments/AttachmentCard";
import UploadButton from "components/Attachments/UploadButton";
import { observer } from "mobx-react";
import { AdditiveAttachmentStore, MessageStore } from "store";
import { lang } from "../../../i18nLang";
import { Title } from "./styles";

const useStyles = makeStyles({
  container: {
    marginTop: "0.25rem",
    padding: "0px 3.5rem",
  },
  paddingItem: { padding: "5px 2.5px" },
});

const TabAttachments = observer(() => {
  const classes = useStyles();

  const handleChangeFiles = (files: File[]) => {
    if (!AdditiveAttachmentStore.validadeAttachmentsCount(files)) {
      MessageStore.error(lang("attachments.errors.maximumFilesCount"));
      return;
    }

    const promises = Array.from(files).map((file) =>
      AdditiveAttachmentStore.uploadAdditiveAttachment(file)
    );
    Promise.all(promises);
  };

  const handleDeleteCard = (attachment: AttachmentModel) => {
    AdditiveAttachmentStore.removeAdditiveAttachment(attachment);
  };

  return (
    <>
      <Title>{lang(`importation.modeFile.subtitleAtt`)}</Title>
      <Grid container item xs={12} md={12} className={classes.container}>
        <Grid container>
          <Grid item xs={12} className={classes.paddingItem}>
            <UploadButton
              color={"#757575"}
              showLabel={true}
              onChangeFiles={handleChangeFiles}
            />
          </Grid>
          {AdditiveAttachmentStore.attachments.map((att) => (
            <Grid item xs={4} className={classes.paddingItem} key={att.uid}>
              <AttachmentCard attachment={att} onDelete={handleDeleteCard} />
            </Grid>
          ))}
        </Grid>
      </Grid>
    </>
  );
});

export default TabAttachments;
